export default __webpack_public_path__ + "4e7625d82aa8880e64630b2bb662b9a3.ico";